import cloneDeep from 'lodash/cloneDeep';
import { useState } from 'react';

// This hook is for Allegiant Stadium Games
// The game data is set in the landing page (when the user selects a game)
const useStadiumGame = () => {
  const [stadiumGame, setStadiumGame] = useState({});
  const _setStadiumGame = game => {
    setStadiumGame(cloneDeep(game));
  };
  const _stadiumGame = {
    date: stadiumGame.date,
    quantity: stadiumGame.quantity,
    maxSeatsAvailable: stadiumGame.maxSeatsAvailable,
    conditions: {
      OPPONENT_CITY: stadiumGame.showConditions?.OPPONENT_CITY,
      PACKAGE_ID: stadiumGame.showConditions?.PACKAGE_ID,
      OPPONENT_NAME: stadiumGame.showConditions?.OPPONENT_NAME,
    },
  };
  return [_stadiumGame, _setStadiumGame];
};
export default useStadiumGame;
